import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  header: {
    padding: '1rem',
    fontSize: theme.size.sm
  },

  body: {
    display: 'block',
    fontSize: theme.size.sm
  },

  layout: {
    display: 'grid',
    gridTemplateColumns: '320px minmax(50px, auto)',
    gridGap: '1rem',
    [theme.breakpoints.down('md')]: {
      gridTemplateRows: 'auto auto',
      gridTemplateColumns: 'minmax(50px, auto)'
    }
  },

  calendar: {
    height: 'calc(100svh - 300px)',
    [theme.breakpoints.down('md')]: {
      height: 'calc(100svh - 200px)',
      gridArea: 1
    }
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'transparent'
  },

  dot: {
    height: 12,
    width: 12,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    display: 'inline-block'
  },

  reminderDot: {
    height: 12,
    width: 12,
    backgroundColor: theme.palette.altColor,
    borderRadius: '50%',
    display: 'inline-block'
  },

  sideNav: {
    [theme.breakpoints.down('md')]: {
      gridArea: 2
    }
  },

  legendContanier: {
    marginTop: '1rem',
    marginLeft: '1rem'
  }
}))

export default useStyles
